import $ from 'jquery';
import axios from 'axios';
import styleSelect from 'styleselect';

const jsrender = require('jsrender')($);

$(document).ready(function () {
    const $sitemap = $('.m-sitemap');
    const pageData = {};
   
    if ($sitemap.length === 0) {
        return;
    }

    LoadData();

    function LoadData() {
        const params = {};
        params["culture"] = $('html').attr('lang').split('-')[0];
        axios.get("/common/sitemap", { params }).then(function (response) {
            pageData["sitemapItems"] = response.data;
            LoadPage();
        });

    }

    function LoadPage() {
        LoadSitemapSection();
        $("#dataLoadingSpinner").remove();
    }

    function LoadSitemapSection() {
        const sitemapListTmpl = jsrender.templates('#sitemapListTmpl');
        const $listSitemap = $('.list-sitemap');
        const html = sitemapListTmpl.render(pageData);
        $listSitemap.html(html);
    }

});



// WEBPACK FOOTER //
// ./app/ui/modules/site-map/index.js